export default __webpack_public_path__ + "static/media/S (20).12b6ec5f.png";